export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/spss.5d77c15.svg";